"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class MessagePricesProvider extends DataProvider_1.default {
    get fragments() {
        return {
            MessagePrices: () => `
        ... on MessagePrices {
          perMinutePriceId
          perSentPriceId
          perSentWithAttachmentPriceId
          userId
          subscriberPerSentPriceId
          subscriberPerSentWithAttachmentPriceId
        }
      `,
        };
    }
    find({ userIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("messagePricesFind", { userIds }, this.getFragment("MessagePrices"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("messagePricesUpdate", { data }, this.getFragment("MessagePrices"));
        });
    }
}
exports.MessagePricesProvider = MessagePricesProvider;
//# sourceMappingURL=MessagePricesProvider.js.map